module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/geofence/geofence.component.css
// module id = ./src/app/geofence/geofence.component.css
// module chunks = main